// The CareerOS brand mark. Renders the logo at a given size.
// Replaces the old "C in a blue square" placeholder.
//
// Prefer this over an inline <img> so future rebrands touch one file only.
export default function BrandMark({ size = 32, className = "", ...rest }) {
  const px = typeof size === "number" ? `${size}px` : size;
  return (
    <img
      src="/careeros-mark-256.png"
      alt="CareerOS"
      width={size}
      height={size}
      loading="eager"
      decoding="async"
      style={{ width: px, height: px }}
      className={`shrink-0 select-none pointer-events-none ${className}`}
      draggable={false}
      {...rest}
    />
  );
}
